import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useTokenStore } from '@/stores/token'
import { useRequestsStore } from '@/stores/requests'
import { useTranslaterStore } from '@/stores/translater'
import { useCarsStore } from '@/stores/cars'
import parseMinutes from "@/helpers/parseMinutes"

export const usePointsStore = defineStore('points', () => {

    const configStore   = useConfigStore()
    const tokenStore    = useTokenStore()
    const requestStore  = useRequestsStore()
    const getTranslate  = useTranslaterStore().getTranslate
    const carsStore     = useCarsStore()

    const point = ref({})
    const cars = ref({})
    const carStateMsg = ref('')
    const carConnection = ref(null)
    const latestPoint = ref({})
    const latestPointProcess = ref(false)
    const latestPointMsg = ref({})

    const connectionType = ref({
        type: '',
        level: 0
    })

    const carState = ref({
        // door_trunk: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 13
        // },
        engine_on: {
            value: null,
            value_text: '',
            unit: '',
            id: 43
        },
        engine_off: {
            value: null,
            value_text: '',
            unit: '',
            id: 44
        },
        // start_moving: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 45
        // },
        // stop_moving: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 46
        // },
        ride_time: {
            value: null,
            value_text: '',
            unit: 'UNIT_MINUTE',
            id: 34
        },
        sdm_uptime : {
            value: null,
            value_text: '',
            unit: 'UNIT_MINUTE',
            id: 128
        },
        // wheel_front_left_pressure: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_ATM',
        //     id: 22
        // },
        // wheel_front_right_pressure: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_ATM',
        //     id: 23
        // },
        // wheel_back_left_pressure: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_ATM',
        //     id: 24
        // },
        // wheel_back_right_pressure: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_ATM',
        //     id: 25
        // },
        // wheel_front_left_status: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 37
        // },
        // wheel_front_right_status: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 38
        // },
        // wheel_back_left_status: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 39
        // },
        // wheel_back_right_status: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 40
        // },
        // door_front_left: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 9
        // },
        // door_front_right: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 10
        // },
        // door_back_left: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 11
        // },
        // door_back_right: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 12
        // },
        // service_date: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 114
        // },
        // engine_oil_lvInd: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 55
        // },
        // door_hood: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 8
        // },
        battery_voltage: {
            value: null,
            value_text: '',
            unit: 'UNIT_VOLT',
            id: 21
        },
        // window_fully_closed_FL: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 117
        // },
        // window_fully_closed_FR: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 118
        // },
        // window_fully_closed_RL: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 119
        // },
        // window_fully_closed_RR: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 120
        // },
        // gear_position: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 48
        // },
        last_navigation_time: {
            value: null,
            value_text: '',
            unit: '',
            id: 50
        },
        last_can_param_time: {
            value: null,
            value_text: '',
            unit: '',
            id: 51
        },
        last_online: {
            value: null,
            value_text: '',
            unit: '',
            id: 0
        },
        online: {
            value: null,
            value_text: '',
            unit: '',
            id: 0
        },
        // total_mileage: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_KM',
        //     id: 15
        // },
        // service_mileage: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_KM',
        //     id: 115
        // },
        ride_mileage: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 31
        },
        status: {
            value: null,
            value_text: '',
            unit: '',
            id: 1
        },
        // is_locked: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 14
        // },
        // battery_status: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 41
        // },
        // TPMS_battery_status_FL: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 96
        // },
        // TPMS_battery_status_FR: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 97
        // },
        // TPMS_battery_status_RL: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 98
        // },
        // TPMS_battery_status_RR: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 99
        // },
        // vas_activation: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 129
        // },
        ride_fuel_consumption: {
            value: null,
            value_text: '',
            unit: 'UNIT_MLITER',
            id: 33
        },
        // fuel_consumption: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_LITER_100_KM',
        //     id: 18
        // },
        ride_average_speed: {
            value: null,
            value_text: '',
            unit: 'UNIT_KMH',
            id: 32
        },
        // front_inside_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 121
        // },
        // back_inside_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 122
        // },
        temperature_outside: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 7
        },
        // front_left_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 3
        // },
        // front_right_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 4
        // },
        // back_left_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 5
        // },
        // back_right_temperature: {
        //     value: null,
        //     value_text: '',
        //     unit: '°C',
        //     id: 6
        // },
        // oil_level: {
        //     value: null,
        //     value_text: '',
        //     unit: '%',
        //     id: 56
        // },
        // washer_fluid: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 35
        // },
        // coolant_fluid: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 36
        // },
        fuel: {
            value: null,
            value_text: '',
            unit: 'UNIT_LITER',
            id: 17
        },
        // engine_time: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_HOUR',
        //     id: 130
        // },
        total_mileage_am: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 131
        },
        // total_avg_speed_am: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_KMH',
        //     id: 132
        // },
        // total_mins_am: {
        //     value: null,
        //     value_text: '',
        //     unit: '',
        //     id: 133
        // },
        // cruising_range: {
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_KM',
        //     id: 134
        // },
        // ocu_fl_stat: {
        //     value: null,
        //     value_text: '',
        //     unit: ''
        // }, 
        // ocu_fr_stat: {
        //     value: null,
        //     value_text: '',
        //     unit: ''
        // }, 
        // ocu_rl_stat: {
        //     value: null,
        //     value_text: '',
        //     unit: ''
        // }, 
        // ocu_rr_stat: {
        //     value: null,
        //     value_text: '',
        //     unit: ''
        // },
        trip_acceleration: {
            value: null, 
            value_text: '',
            unit: ''
        },
        trip_braking: {
            value: null, 
            value_text: '',
            unit: ''
        },
        total_acceleration: {
            value: null, 
            value_text: '',
            unit: ''
        },
        total_braking: {
            value: null, 
            value_text: '',
            unit: ''
        },
        sat: {
            value: null, 
            value_text: '',
            unit: ''
        },
        // not_set: {
        //     value: null, 
        //     value_text: '',
        //     unit: ''
        // },
        mov: {
            value: null, 
            value_text: '',
            unit: ''
        },
        received_signal_strength_indicator: {
            value: null, 
            value_text: '',
            unit: 'dBm'
        },
        mobile_network_type_indicator: {
            value: null, 
            value_text: '',
            unit: ''
        },
        // alarm_system: {
        //     value: null, 
        //     value_text: '',
        //     unit: ''
        // },
        SRC: {
            value: null, 
            value_text: '',
            unit: ''
        },
        ANS1: {
            value: null, 
            value_text: '',
            unit: ''
        },
        ANS2: {
            value: null, 
            value_text: '',
            unit: ''
        },
        ANS3: {
            value: null, 
            value_text: '',
            unit: ''
        },
        ANS4: {
            value: null, 
            value_text: '',
            unit: ''
        },
        ANS5: {
            value: null, 
            value_text: '',
            unit: ''
        },
        DIG1: {
            value: null, 
            value_text: '',
            unit: ''
        },
        DIG2: {
            value: null, 
            value_text: '',
            unit: ''
        },
        DIG3: {
            value: null, 
            value_text: '',
            unit: ''
        },
        DIG4: {
            value: null, 
            value_text: '',
            unit: ''
        },
        DIG5: {
            value: null, 
            value_text: '',
            unit: ''
        },
        CONN_TYPE: {
            value: null, 
            value_text: '',
            unit: ''
        }, 
        coolant_temperature: {
            value: null,
            value_text: '',
            unit: '°C'
        }
    })

    async function readLatestPoint(payload) {

        const token = tokenStore.access
        let result = {}
        
        if(token) {

            latestPointProcess.value = true

            let params = ''

            if(payload) {

                for( let param in payload) {

                    if(typeof payload[param] == 'object' && payload[param].length) {

                        payload.uuid_car_array.map( el => {

                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })

                    } else {

                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/cars/points/latest${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                request.array.map(data => {
                    point.value = data
                    readPoints(data)
                })

                result = request

                latestPointMsg.value = { success: true, text: '' }

            } else {

                latestPointMsg.value = { success: false }
                latestPointMsg.value.text = getTranslate[request.error] || request.error
            }

            latestPointProcess.value = false

        } else {

            latestPointMsg.value = { success: false, text: getTranslate.EUnauthRequest }
        }

        return result
    }

    async function readPoints(msg) {

        if(!carsStore.cars[msg.car]) {

            carsStore.cars[msg.car] = {}
        }

        // Стейты автомобиля
        let states = msg.s || []

        for( let carStateItem of states ) {

            let value       = '',
                value_text  = ''

            if( 'value' in carStateItem ) {

                if( 'd' in carStateItem.value) value = Number(carStateItem.value.d) // Целое число
                if( 'i' in carStateItem.value) value = Number(carStateItem.value.i) // Число с плавающей точкой
                if( 's' in carStateItem.value) value = String(carStateItem.value.s) // Строка

            } else {

                if( ![

                    'engine_on',
                    'engine_off',
                    'start_moving',
                    'stop_moving',
                    'last_navigation_time',
                    'last_can_param_time'

                ].includes(carStateItem.key) ) {

                    value = 0
                }
            }

            if( carStateItem.valid === true ) {

                switch(carStateItem.key) {
                    case 'high_beam_left_status':
                    case 'rear_fog_light_status':
                    case 'front_left_fog_light_status':
                    case 'front_right_fog_light_status':
                    case 'brake_light_left_status':
                    case 'brake_light_right_status':
                    case 'brake_light_HM_status':
                    case 'mil_onRq':
                    case 'mil_ind_blink':
                    case 'high_beam_right_status':
                    case 'low_beam_left_status':
                    case 'low_beam_right_status':
                    case 'reverse_light_left_status':
                    case 'reverse_light_right_status':
                    case 'position_light_RL_status':
                    case 'position_light_RR_status':
                    case 'cornering_light_left_status':
                    case 'cornering_light_right_status':
                    case 'daytime_light_left_status':
                    case 'daytime_light_right_status':
                    case 'turn_indicator_FL_status':
                    case 'turn_indicator_FR_status':
                    case 'turn_indicator_ML_status':
                    case 'turn_indicator_MR_status':
                    case 'turn_indicator_RL_status':
                    case 'turn_indicator_RR_status':
                    case 'position_light_FL_status':
                    case 'position_light_FR_status':
                    case 'head_light_leveling_ctrl_failure':
                    case 'SCU_fault_status':
                    case 'ABS_lamp':
                    case 'EBD_lamp':
                    case 'TCS_lamp':
                    case 'TPMS_sensor_fault_FL':
                    case 'TPMS_sensor_fault_FR':
                    case 'TPMS_sensor_fault_RL':
                    case 'TPMS_sensor_fault_RR':
                    case 'T15_fault_status':
                    case 'T30i_fault_status':
                    case 'T30d_fault_status':
                    case 'BCM_warning_indicator':
                    case 'DMFL_warning_indicator':
                    case 'DMFR_warning_indicator':
                    case 'DMRL_warning_indicator':
                    case 'DMRR_warning_indicator':
                    case 'ESP_lamp':
                    case 'TM_warning_indicator':
                        switch(value) {
                            case 0: value = 'No failure'
                                break
                            case 1: value = 'Failure'
                                break
                        }
                        break

                    case 'TPMS_battery_status_FL':
                    case 'TPMS_battery_status_FR':
                    case 'TPMS_battery_status_RL':
                    case 'TPMS_battery_status_RR':
                        switch(value) {
                            case 0: value_text = 'STATE_TPMS_BATTERY_NORMAL'
                                break
                            case 1: value_text = 'STATE_TPMS_BATTERY_LOW'
                                break
                        }
                        break  

                    case 'SCU_calibration_status':
                        switch(value) {
                            case 0: value = 'Calibrated'
                                break
                            case 1: value = 'Uncalibrated'
                                break
                        }
                        break

                    case 'CCU_failure':
                        switch(value) {
                            case 0x0: value = 'No Failure'
                                break
                            case 0x1: value = 'Full Failure'
                                break
                            case 0x2: value = 'Failure in front zone'
                                break
                            case 0x3: value = 'Failure in rear zone'
                                break
                            case 0x4: value = 'Failure with pressure in the circuit'
                                break
                            case 0x5: value = 'Failure with some sensors'
                                break
                            case 0x6: value = 'Failure with'
                                break
                        }
                        break

                    case 'st_transmission_warning':

                        switch(value) {
                            case 1: value = 'Overheat'
                                break
                            case 3: value = 'Critical Failure'
                                break
                            case 4: value = 'No Failure'
                                break
                            case 5: value = 'Limited Functionality'
                                break
                            case 6: value = 'Drive to stop'
                                break
                            case 'E': value = 'Not Available'
                                break
                            case 'F': value = 'Default'
                                break
                        }
                        break

                    case 'status': 

                        switch(value) {
                            case 0: value = 'Deep sleep'
                                break
                            case 1: value = 'Sleep'
                                break
                            case 2: value = 'Standby'
                                break
                            case 3: value = 'Ignition'
                                break
                            case 4: value = 'Drive'
                                break
                            case 5: value = 'Remote start'
                                break
                            case 8: value = 'Preheating'
                                break
                            case 9: value = 'Comfort'
                                break
                            case 10: value = 'Multimedia'
                                break
                            case 15: value = 'Unknown'
                                break
                            default: value = 'Reserve'
                                break
                        }
                        break

                    case 'ERAG_failure_status':
                        switch(value) {
                            case 0: value = 'No failure'
                                break
                            case 1: value = 'Unavailable microphone'
                                break
                            case 2: value = 'Unavailable speaker'
                                break
                            case 3: value = 'Unavailable SOS button'
                                break
                            case 4: value = 'Unavailable GPS'
                                break
                            case 5: value = 'Unavailable GSM'
                                break
                            case 6: value = 'Full Failure'
                                break
                        }
                        break

                    case 'HV_system_failure':
                        switch(value) {
                            case 0: value = 'No failure'
                                break
                            case 1: value = 'No energy source available'
                                break
                            case 2: value = 'Warning'
                                break
                            case 3: value = 'Error'
                                break
                        }
                        break

                    case 'LTC_coolant_lvl':
                        switch(value) {
                            case 0: value = 'Normal'
                                break
                            case 1: value = 'Low'
                                break
                        }
                        break

                    case 'engine_oil_lvInd': 
                        switch(value) {
                            case 0: value_text = 'LEVEL_NORMAL'
                                break
                            case 1: value_text = 'LEVEL_LOW'
                                break
                            case 2: value_text = 'LEVEL_HIGH'
                                break
                            case 3: value_text = 'LEVEL_CRITICAL_LOW'
                                break
                        }
                        break

                    case 'oil_pressure_warning':
                        switch(value) {
                            case 0: value = 'Normal'
                                break
                            case 1: value = 'Low'
                                break
                        }
                        break

                    case 'temperature_outside':
                        value = Number(value).toFixed()
                        break

                    case 'front_inside_temperature':
                    case 'back_inside_temperature':
                        value = value.toFixed(1)
                        break

                    case 'front_left_temperature':
                    case 'front_right_temperature':
                    case 'back_left_temperature':
                    case 'back_right_temperature':
                        value = String(value.toFixed(1)).split('.')
                        break

                    case 'door_hood':
                        switch(value) {
                            case 0: value_text = getTranslate.STATE_CLOSED
                                break
                            case 1: value_text = getTranslate.STATE_OPEN
                                break
                        }
                        break

                    case 'door_front_left':
                    case 'door_front_right':
                    case 'door_back_left':
                    case 'door_back_right':
                        switch(value) {
                            case 0: value_text = getTranslate.STATE_CLOSED 
                                break
                            case 1: value_text = getTranslate.STATE_OPEN
                                break
                        }
                        break

                    case 'is_locked':
                        switch(value) {
                            case 1: value_text = getTranslate.STATE_OPEN
                                break
                            case 2: value_text = getTranslate.STATE_CLOSED
                                break
                            case 3: value_text = getTranslate.STATE_LOCK_SECURE
                                break
                            case 4: value_text = getTranslate.STATE_LOCK_SECURE
                                break
                        }
                        break

                    case 'total_mileage':
                        value = Number(value).toFixed(1)
                        break

                    case 'total_mileage_am':
                        value = Number(value).toFixed(1)
                        break

                    case 'fuel':
                        value = value.toFixed(1)
                        break
                        
                    case 'fuel_consumption':
                        value = value.toFixed(1)
                        break

                    case 'door_trunk':
                        switch(value) {
                            case 1: value_text = getTranslate.STATE_HALF_OPEN
                                break
                            case 2: value_text = getTranslate.STATE_OPEN
                                break
                            case 3: value_text = getTranslate.STATE_CLOSED
                        }
                        break

                    case 'epb_status':
                        switch(value) {
                            case 0: value = 'OFF'
                                break
                            case 1: value = 'ON'
                                break
                            case 2: value = 'Dynamic'
                                break
                            case 3: value = 'Failure Indication'
                        }
                        break
                        
                    case 'battery_voltage':
                        value = value.toFixed(1)
                        break
                        
                    case 'wheel_front_left_pressure':
                        value = value.toFixed(1)
                        break
                        
                    case 'wheel_front_right_pressure':
                        value = value.toFixed(1)
                        break

                    case 'wheel_back_left_pressure':
                        value = value.toFixed(1)
                        break
                        
                    case 'wheel_back_right_pressure':
                        value = value.toFixed(1)
                        break

                    case 'engine_rev':
                        value = Number(value).toFixed()
                        break
                        
                    case 'door_front_left_closed':
                    case 'door_front_right_closed':
                    case 'door_back_left_closed':
                    case 'door_back_right_closed':
                        switch(value) {
                            case 0: value = getTranslate.STATE_OPEN
                                break
                            case 1: value = getTranslate.STATE_CLOSED
                                break
                            case 2: value = getTranslate.STATE_ERROR
                                break
                        }
                        break

                    case 'ride_mileage':
                        value = Number(value).toFixed(1)
                        break

                    case 'ride_average_speed':
                        value = value ? value.toFixed(1) : value
                        break

                    case 'ride_fuel_consumption':
                        value = value.toFixed(1)
                        break

                    case 'ride_time':
                        value_text = value ? parseMinutes(value, 'sec') : null
                        break

                    case 'wheel_front_left_status':
                    case 'wheel_front_right_status':
                    case 'wheel_back_left_status':
                    case 'wheel_back_right_status':
                        switch(value) {
                            case 1: value_text ='STATE_WHEEL_PRESSURE_STATUS_HIGH'
                                break
                            case 2: value_text ='STATE_WHEEL_PRESSURE_STATUS_NORMAL'
                                break
                            case 3: value_text ='STATE_WHEEL_PRESSURE_STATUS_LOW'
                                break
                            case 4: value_text ='STATE_WHEEL_PRESSURE_STATUS_CRITICAL'
                                break
                            case 6: value_text ='STATE_WHEEL_PRESSURE_STATUS_ERROR'
                                break
                            default: value_text = ''
                                break
                        }
                        break
                    
                    case 'coolant_fluid': 
                        switch(value) {
                            case 0: value_text ='STATE_COOLANT_FLUID_NORMAL'
                                break
                            case 1: value_text ='STATE_COOLANT_FLUID_LOW'
                                break
                        }
                        break

                    case 'online':

                        switch(value) {

                            case 0: 
                                value_text = 'STATE_OFFLINE'
                                if(carStateItem.updateAt) {
                                    carState.value.last_online.value = new Date( carStateItem.updateAt * 1000).toLocaleString()
                                } else {
                                    carState.value.last_online.value = null
                                }
                                break

                            case 1: 
                                value_text = 'STATE_ONLINE'
                                carState.value.last_online.value = 'STATE_ONLINE'
                                break

                            case 2: 
                                value_text = 'STATE_ONLINE'
                                carState.value.last_online.value = 'STATE_ONLINE'
                                break
                        }

                        break

                    case 'washer_fluid':
                        switch(value) {
                            case 0: value_text ='Normal'
                                break
                            case 1: value_text ='Low level'
                                break
                        }
                        break

                    case 'battery_status':
                        switch(value) {
                            case 0: value_text ='Normal'
                                break
                            case 1: value_text ='Low SOC'
                                break
                        }
                        break

                    case 'gear_position':
                        switch(value) {
                            case 1: value = 'P'
                                break
                            case 2: value = 'R'
                                break
                            case 3: value = 'N'
                                break
                            case 4: value = 'D'
                                break
                        }
                        break

                    case 'oil_level':
                        value = Math.round(value)
                        break

                    case 'engine_on':
                    case 'engine_off':
                    case 'start_moving':
                    case 'stop_moving':
                    case 'last_navigation_time':
                    case 'last_can_param_time':
                        value = new Date(carStateItem.updateAt * 1000).toLocaleString()
                        break

                    case 'window_fully_closed_FL':
                    case 'window_fully_closed_FR':
                    case 'window_fully_closed_RL':
                    case 'window_fully_closed_RR':
                        switch(value) {
                            case 0: value_text = getTranslate.STATE_NOT_CLOSED
                                break
                            case 1: value_text = getTranslate.STATE_CLOSED
                                break
                        }
                        break

                    // Данные компонента ASConnectionType [НАЧАЛО]
                    case 'received_signal_strength_indicator':
                        connectionType.value.level = value
                        break

                    case 'mobile_network_type_indicator':
                        connectionType.value.type = value
                        break
                    // Данные компонента ASConnectionType [КОНЕЦ]

                    // case 'vehicle_secure_lock_state':
                    //     switch(value) {
                    //         case 0: value = 'Unsecure'
                    //             break
                    //         case 1: value = 'Secure'
                    //             break
                    //     }
                    //     break

                    case 'vas_activation':
                        switch(value) {
                            case 0: value = 'Unguarded'
                                break
                            case 1: value = 'Guarded'
                                break
                        }
                        break

                    case 'sdm_uptime':
                        value = value !== 0 ? parseMinutes(value) : null
                        break

                    case 'total_avg_speed_am':
                        value = Number(value).toFixed(1)
                        break

                    case 'total_mins_am':
                        value = parseMinutes(value)
                        break

                    case 'ocu_fl_stat': 
                    case 'ocu_fr_stat': 
                    case 'ocu_rl_stat': 
                    case 'ocu_rr_stat': 
                        if(![0, 1, 2, 3, 4, 5].includes(Number(value))) {

                            value = null
                        }
                        break

                    case 'coolant_temperature': 
                        value = Number(value).toFixed()
                        break
                }

            } else {

                value = null
            }

            if(carState.value[carStateItem.key]) {

                carState.value[carStateItem.key].value      = value
                carState.value[carStateItem.key].value_text = value_text
                carsStore.cars[msg.car][carStateItem.key] = { value, value_text }
            }
        }

        point.value = msg
    }

    // Проверка актуальности carState ВРУЧНУЮ
    function checkCarStates (referenceArr) {

        const carStateArr = Object.keys(carState.value)

        const diff = (arr1, arr2) => {
            return arr1.filter(item => !arr2.includes(item))
        }

        console.log('needAdd: ', diff(referenceArr, carStateArr))
        console.log('needDelete: ', diff(carStateArr, referenceArr))
    }

    function resetCarState() {
        for(let item in carState.value) {
            carState.value[item].value = null
            carState.value[item].value_text = '–'
        }
        point.value = {}
        latestPoint.value = {}
    }

    const resetConnectionType = () => connectionType.value  = {
        type: '',
        level: 0
    }

    return {

        point, 
        cars, 
        carStateMsg, 
        carConnection, 
        latestPoint, 
        latestPointProcess, 
        latestPointMsg, 
        connectionType, 
        carState, 
        readLatestPoint, 
        readPoints, 
        checkCarStates, 
        resetCarState, 
        resetConnectionType
    }
})
